<template>
	<div class="h-100">
		<el-row :gutter="20">
			<el-col :span="6">
				<sf-select-group
					:label="getMessage_('SWCC000583')"
					labelPosition="left"
					:labelSpan="12"
					:inputValue="!isEmptyObject(sqlDetails) ? sqlDetails[db] : null"
					:options="dbInfos"
					:onChange="value => onChange({ key: db, value })"
				/>
			</el-col>
		</el-row>
		<el-row :gutter="20">
			<el-col :span="24">
				<sf-input-group
					class="sql__textarea"
					:label="getMessage_('SWCC000579')"
					inputType="textarea"
					:inputValue="!isEmptyObject(sqlDetails) ? sqlDetails[sql] : null"
					:onChange="value => onChange({ key: sql, value })"
				/>
			</el-col>
		</el-row>
		<el-row :gutter="20">
			<el-col :span="24">
				<sf-button v-if="isButton_(scrId, 'AD')" :style="{ float: 'right', marginTop: '10px' }" :onClick="onSave">
					{{ getMessage_('SWCC000327') }}
				</sf-button>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/SyncManagement/store/helpers';
import * as yup from 'yup';
import { utils } from '@sfaas/util';
export default {
	props: {
		db: {
			type: String,
			default: ''
		},
		sql: {
			type: String,
			default: ''
		},
		scrId: { type: String, default: '' }
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		schema() {
			return yup.object().shape({
				procId: yup.string().nullable().required(this.getMessage_('SWCC000500'))
			});
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		...utils,
		onChange({ key, value }) {
			this.DEFAULT_ASSIGN({
				key: 'sqlDetails',
				value: {
					...this.sqlDetails,
					[key]: value
				}
			});
		},
		onSave() {
			try {
				this.schema.validateSync(this.selectedRow);

				const { plantCd, procId } = this.selectedRow;
				this.$sf_toggleLoading(true);
				this.saveSqlDetails_({ plantCd, procId, sqlDetails: [{ ...this.sqlDetails, procId, regId: 'JHPARK' }] })
					.then(header => {
						this.$sf_toast({
							...this.$sf_setToastOption(header),
							message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
						});
					})
					.catch(error => {
						this.$sf_toast({ type: 'error', message: error.message });
					})
					.then(() => this.fetchSqlDetails_({ plantCd, procId }))
					.finally(() => this.$sf_toggleLoading(false));
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		}
	}
};
</script>

<style lang="scss">
.sql__textarea {
	textarea {
		height: 350px;
	}
}
</style>
